const { toAuto, fromAuto } = require('./util/auto-height-animate');

export default () => jQuery(($) => {
    $(".overlay__container--has_enclosure").each(function(){
        let container = $(this);
        let content = container.find('.overlay__content');
        //let wrapper = container.find('.overlay__content-enclosure-wrap');
        let enclosure = container.find('.overlay__enclosure');
        $(this).find('.overlay__disclose-button').click(function(){
            content.css("width", content.width() + "px").css("height", content.height() + "px");
            window.setTimeout(function(){
                content.css("width", "").css("height", "");
            }, 500);
            if(container.hasClass("overlay__container--open")) {
                // close
                container.removeClass("overlay__container--open").addClass("overlay__container--closing").addClass("overlay__container--close-start");
                window.setTimeout(function(){
                    container.addClass("overlay__container--closed").removeClass("overlay__container--closing");
                }, 500);
                window.setTimeout(function(){
                    container.removeClass("overlay__container--close-start");
                }, 10);
            } else {
                // open
                container.addClass("overlay__container--opening").addClass("overlay__container--open-start").removeClass("overlay__container--closed");
                window.setTimeout(function(){
                    container.addClass("overlay__container--open").removeClass("overlay__container--opening");
                    enclosure.height(content.height());
                    toAuto(enclosure, 250);
                }, 500);
                window.setTimeout(function(){
                    container.removeClass("overlay__container--open-start");
                }, 10);
            }
        });
    });
    $(".overlay__mobile-disclose-button").click(function(){
        $(this).closest(".overlay__container").find(".overlay__content-enclosure-wrap, .overlay__foot").toggleClass("overlay__content-enclosure-wrap--hidden");
        $(this).toggleClass("overlay__mobile-disclose-button--open");
    });
    $(".overlay__content-enclosure-wrap, .overlay__foot").addClass("overlay__content-enclosure-wrap--hidden");
});
